import { render, staticRenderFns } from "./HomeRouteButton.vue?vue&type=template&id=7229844d&scoped=true&"
import script from "./HomeRouteButton.vue?vue&type=script&lang=js&"
export * from "./HomeRouteButton.vue?vue&type=script&lang=js&"
import style0 from "./HomeRouteButton.vue?vue&type=style&index=0&id=7229844d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229844d",
  null
  
)

export default component.exports